import {atom} from "recoil";
import {persistAtomEffect} from "../effects/persistAtom";

export const csatViewedListState = atom({
  key: 'csatViewedListState',
  default: [],
  effects: [
    persistAtomEffect
  ]
});
